<template>
  <div id="date-range-container" class="dropdown">
        <span class="header-label">
          {{ header }}
        </span>
        <base-input
          label=""
          type="text"
          field="dateRange"
          :enableTextboxStyle="false"
          :value="dateRangeFormatted"
          :remove_default_margin="true"
          cus_style="
          margin-bottom: 0; 
          padding: 0.2rem 0.4rem 0.2rem 135px; 
          width: 360px; 
          height: 35px;
          font-family: Quicksand-Medium;
          cursor: pointer;
          caret-color: transparent;
          "
          >
            <template v-slot:prefix>
            <div class="date-label">
                {{ dateRangeLabel || currentLabel }}
            </div>
            </template>
        </base-input>
        <div class="content-container dropdown-menu-1"
          :style="right?'right:0': 'left:0'"
          v-if="showDatepicker"
          >
          <b-row tabindex="0" class="no-gutter my-2 p-2"> <!-- tab index makes it focusable -->
            <b-col cols="2" class="label-list">
            <div
                v-for="(label, index) in dateRangeLabels"
                :class="[
                'label-list-item',
                { active: dateRangeLabel === label ? true : false },
                ]"
                :key="index"
                @click.stop="setDateRange(label)"
            >
                {{ label }}
            </div>
            </b-col>
            <b-col cols="4" style="margin-right: 3rem; display: flex; flex-direction: column;">
            <span class="cal-label">From</span>
            <v-date-picker 
                ref="startSelector"
                :select-attribute="attribute"
                :drag-attribute="attribute"
                :class="[{show: showDatepicker}, 'no-border']"
                :value="dateRange.start"
                @dayclick="(...args) => handleDayClick('start',...args)"
                is-required
            />
            </b-col>
            <b-col cols="5" style="display: flex; flex-direction: column;">
            <span class="cal-label">To</span>
            <v-date-picker 
            ref="endSelector"
            :select-attribute="attribute"
            :drag-attribute="attribute"
            :class="[{show: showDatepicker}, 'no-border']"
            @dayclick="(...args) => handleDayClick('end',...args)"
            :value="dateRange.end"
            is-required
            />
            </b-col>
          </b-row>
        </div>
    </div>
</template>

<script>
import BaseInput from '@/components/UI/BaseInput.vue';
import { DateTime } from 'luxon';

export default {
  name: "desktop-date-range-picker",
  props: {
    attribute: {
      required: true,
      type: Object,
    },
    dateRange: {
      required: true,
      type: Object,
    },
    ranges: {
      required: true,
      type: Object,
    },
    preventEmit: {
      required: true,
      type: Boolean,
    },
    dateRangeLabel: {
      required: false,
      default: null,
    },
    avoidUpdatingLabel: {
      required: true,
      type: Boolean,
    },
    showDatepicker: {
      required: true,
      type: Boolean,
    },
    header: {
      required: true,
      type: String,
    },
    right: {
      required: false,
      type: Boolean,
    },
  },
  components: {
    BaseInput,
  },
  methods: {
    handleDayClick(dateType, dateObj) {
      if(dateType == 'start'){
        var diffIndays = Math.ceil(DateTime.fromJSDate(dateObj.date).diff(this.dateRange.start, 'days').values.days);
        Object.assign(this.dateRange, {[dateType]: DateTime.fromJSDate(dateObj.date), 'end': this.dateRange.end.plus({days: diffIndays})})
        this.$emit("preventEmit", true);
      }
      else{
        this.$emit("preventEmit", false);
        Object.assign(this.dateRange, {[dateType]: DateTime.fromJSDate(dateObj.date)})
      }
      this.$emit("update:dateRange", this.dateRange);
    },
    setDateRange(label) {
      let [start, end] = this.ranges[label];
      this.$emit("update:dateRangeLabel", label);
      this.$emit("update:avoidUpdatingLabel", true);
      this.$emit("preventEmit", false);
      this.$emit(
          "update:dateRange", 
          Object.assign(this.dateRange, {
                  start,
                  end
              })
      );

      this.$refs.startSelector.move(start);
      this.$refs.endSelector.move(end);
    }
  },
  computed: {
      dateRangeFormatted() {
        if (!this.dateRange.start || !this.dateRange.end) {
          return '                   —';
        }
        return `${this.$formatDate(this.dateRange.start)} — ${this.$formatDate(this.dateRange.end)}`;
      },
      dateRangeLabels() {
        return Object.keys(this.ranges);
      },
      comparisonDateRanges() {
        // This is a variable that holds the time of each start and end date to use for comparison
        return Object.entries(this.ranges).map(([key, value]) => {
          return [
            key,
            value.map(dateObj => dateObj)
          ];
        });
      },
      currentLabel() {
        if (!this.dateRange?.start || !this.dateRange?.end) {
          return 'This Month';
        }
        let {start: rangeStart, end:rangeEnd } = Object.assign({}, this.dateRange);
        rangeStart = DateTime.fromJSDate(rangeStart);
        rangeEnd = DateTime.fromJSDate(rangeEnd);
        const startTime = rangeStart.startOf('day'); const endTime = rangeEnd.startOf('day');
        let obj = this.comparisonDateRanges.find((obj) => {
          let [start, end] = obj[1];
          return startTime.date == start.date && endTime.date == end.date && startTime.year == endTime.year;
        });
        return obj && obj[0] || "Custom";
      }
    },
  };
</script>

<style scoped lang="scss">
@import './DesktopDateRangePicker.scss';
</style>
